import React from "react";
import { userManager } from "./userService";
const SilentSigninOidc = () => {
  userManager
    .signinSilentCallback()
    .then(() => console.log("signinSilentCallback completed"));
  return <></>;
};
export default SilentSigninOidc;
